import type { ZuubPayer } from '@/@types/zuub/contracts';
import { StatusChip } from '@/common-components/elements/StatusChip';

import { PayerAvatar } from '../PayerAvatar';
import type { StatusChipProps } from '../helpers/helpers';

interface PayerHeaderProps {
  payer: ZuubPayer;
  statusChipProps: StatusChipProps;
}

export const PayerHeader = ({ payer, statusChipProps }: PayerHeaderProps) => {
  return (
    <div className="vai-flex vai-items-center vai-justify-between vai-gap-4 vai-mb-6">
      <div className="vai-flex vai-items-center vai-gap-4">
        <PayerAvatar payer={payer} size="md" />
        <h2 className="vai-text-xl vai-font-semibold vai-text-gray-900">
          {payer.name}
        </h2>
      </div>
      <StatusChip
        text={statusChipProps.text}
        variant={statusChipProps.variant}
        icon={statusChipProps.icon}
      />
    </div>
  );
};
